import { render } from "./WeddingsCollections.vue?vue&type=template&id=0352df8a&scoped=true"
import script from "./WeddingsCollections.vue?vue&type=script&lang=js"
export * from "./WeddingsCollections.vue?vue&type=script&lang=js"

import "./WeddingsCollections.vue?vue&type=style&index=0&id=0352df8a&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0352df8a"]])

export default __exports__